exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-292ccc26]{margin-top:35px}.handle[data-v-292ccc26]{float:left}.close[data-v-292ccc26],.handle[data-v-292ccc26]{padding-top:8px;padding-bottom:8px}.close[data-v-292ccc26]{float:right}input[data-v-292ccc26]{display:inline-block;width:50%}.text[data-v-292ccc26]{margin:20px}", ""]);

// exports
